
import {initWebComponent} from "@/helpers/web-component-helper";
import {toggleActiveToolButton} from "@/helpers/layer-tools-helper";

export class LayerInfoToolsMutationButtonComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `<layer-info-tools-switcher-button data-title="mutation" data-icon="fa fa-plus"></layer-info-tools-switcher-button>`;

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            toggleActiveToolButton(this, 'layer-info-tools-mutation')
        })
    }
}

